import { Record } from 'immutable';
import { schema } from 'normalizr';

export const InternationalMeterReading = new Record({
  id: undefined,
  energy: undefined,
  reactive_power: undefined,
  real_power: undefined,
  apparent_power: undefined,
  current: undefined,
  voltage: undefined,
  watt_hours: undefined,
  timestamp: undefined,
  site: undefined,
  power_factor: undefined,
});

export const internationalMeterReadingSchema = new schema.Entity('internationalMeterReadings');

// for reading in nested models, object with { field: schema }
// internationalMeterReadingSchema.define({  });
